import React from 'react';
import styles from './../styles/dashboard.module.scss'


const Dashboardcard = ({title, amount }) => {
  return (
    <section className={styles.__card}>
      <p className={styles.__card__title}>{title}</p>
      <span className={styles.__card__amount}>{amount}</span>
    </section>
  )
}

export default Dashboardcard;
